import { useState } from 'react'

export const useImageSlider = () => {
  const [activeModalSlider, setActiveModalSlider] = useState(false)
  const [imageClickedIndex, setImageClickedIndex] = useState(0)

  const handleImageClick = (imageIndex: number) => {
    setImageClickedIndex(imageIndex)
    setActiveModalSlider(true)
  }

  return {
    activeModalSlider,
    setActiveModalSlider,
    imageClickedIndex,
    handleImageClick,
  }
}
